<div class="container">
  <h1 mat-dialog-title>{{ "workorder.confirm-dialog.title" | translate }}</h1>
  <span class="spacer"></span>
  <div class="dialog-msg" mat-dialog-content>
    <p>
      {{ dialogMsg }} <strong>{{ displayInfo }}</strong> ?
    </p>
  </div>

  <div mat-dialog-actions class="actions">
    <button mat-raised-button (click)="onNoClick()">
      {{ "workorder.confirm-dialog.cancel" | translate }}
    </button>
    <button
      mat-raised-button
      [mat-dialog-close]="!data.confirm"
      cdkFocusInitial
    >
      {{ "workorder.confirm-dialog.yes" | translate }}
    </button>
  </div>
</div>
